import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function FooterTop({bg}:{bg:any}) {
  const { t } = useTranslation();

  return (
        <section className={`call-to-act-wrap ${bg}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">

                        <div className="call-to-act">
                            <div className="call-to-act-head">
                                <h3>{t('footerTop.ctaTitle')}</h3>
                                <span>{t('footerTop.ctaSubtitle')}</span>
                            </div>
                            <Link to="https://ampirivieranayarit.com/list-with-us/" className="btn btn-call-to-act">{t('footerTop.ctaButton')}</Link>
                        </div>

                    </div>
                </div>
            </div>
        </section>
  )
}
